import {GridModel} from '@xh/hoist/cmp/grid';
import {HoistModel, LoadSpec, managed, PlainObject, TaskObserver, XH} from '@xh/hoist/core';
import {action, observable} from '@xh/hoist/mobx';
import {getDefaultOptions} from '../../../../../core/ServiceUtils';
import {actionCol} from '@xh/hoist/desktop/cmp/grid';
import {Icon} from '@xh/hoist/icon';
import {fmtLines} from '../../../../cmp/Formaters';
import {Roles} from '../../../../data/DataTypes';

export class SplitProcessorModel extends HoistModel {
    apiTask = TaskObserver.trackLast();
    @observable accessor isOpen = false;
    @managed gridModel = this.createGridModel();

    @action open() {
        this.gridModel.clear();
        this.isOpen = true;
        this.loadAsync();
    }

    @action close() {
        this.isOpen = false;
    }

    async process(split: PlainObject) {
        if (!XH.entitlementService.hasRole(Roles.SEC_MASTER_MANAGER)) {
            XH.dangerToast('You do not have permission to process splits.');
            return;
        }

        var results = await XH.fetchService
            .postJson({
                url: `${XH.getConf('svcApiUrl')}/SecMaster/splits/process`,
                body: split,
                ...getDefaultOptions()
            })
            .linkTo(this.apiTask);

        XH.successToast({timeout: 5000, message: fmtLines(results)});
        this.loadAsync();
    }

    override async doLoadAsync(loadSpec: LoadSpec): Promise<void> {
        const data = await XH.fetchService
            .getJson({
                url: `${XH.getConf('svcApiUrl')}/SecMaster/splits`,
                ...getDefaultOptions()
            })
            .linkTo(this.apiTask);

        this.gridModel.clear();
        this.gridModel.loadData(
            data.map(split => ({
                ...split,
                description: `${split.numerator} for ${split.denominator}`
            }))
        );
    }

    private createGridModel(): GridModel {
        return new GridModel({
            store: {idSpec: 'ticker'},
            sortBy: 'asOfDate',
            columns: [
                {field: 'ticker', width: 95},
                {field: 'asOfDate', width: 120},
                {field: 'description', width: 100},
                {field: 'numerator', align: 'right', width: 110},
                {field: 'denominator', align: 'right', width: 110},
                {
                    ...actionCol,
                    actions: [
                        {
                            icon: Icon.play(),
                            intent: 'success',
                            tooltip: 'Process Split',
                            actionFn: ({record}) => this.process(record.raw)
                        }
                    ]
                }
            ]
        });
    }
}
